import { render, staticRenderFns } from "./MyWorkflows.vue?vue&type=template&id=285b4938&scoped=true&"
import script from "./MyWorkflows.vue?vue&type=script&lang=js&"
export * from "./MyWorkflows.vue?vue&type=script&lang=js&"
import style0 from "./MyWorkflows.vue?vue&type=style&index=0&id=285b4938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285b4938",
  null
  
)

export default component.exports